import { lazy } from 'react';

// project imports
import AuthLayout from '../layout/Auth';
import Loadable from '../shared/common/Loadable';

// jwt auth
const LoginPage = Loadable(lazy(() => import('../../features/login/Index')));
const VerifyOtpPage = Loadable(lazy(() => import('../../features/login/VerifyOtp')));
//const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const AuthRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: '/login',
          element: <LoginPage />
        },
        {
          path: '/verify',
          element: <VerifyOtpPage />
        }
      ]
    }
  ]
};

export default AuthRoutes;
